import React, { Fragment } from 'react';

import type { UrlComponent } from '../../../../../core/data-sources/content-components/types.js';

import YoutubePlayer from './YoutubePlayer.js';
import { LinkWithPulse } from '../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

export interface UrlWrapperProps {
  item: UrlComponent;
  index: number;
  groupIndex: number;
  isMobile: boolean;
}

const UrlWrapper: React.FC<UrlWrapperProps> = ({
  item,
  index,
  groupIndex,
  isMobile,
}) => {
  if (item?.data?.source === 'youtube') {
    if (item.data.customProperties?.videoId) {
      return (
        <YoutubePlayer
          key={`video-player-${item.data.customProperties.videoId}`}
          id={item.data.customProperties.videoId}
          isMobile={isMobile}
        />
      );
    } else {
      return <Fragment />;
    }
  }

  const mapsRegex =
    /https?:\/\/((www\.)?google\.[a-z.]{2,6}(\/maps)?\/?|(goo\.gl\/maps\/\w+))/g;

  const isMaps = mapsRegex.test(item.url);

  const text = isMaps ? 'Se i kart' : 'Nettside';
  const cn = isMaps ? 'map' : 'homepage';

  return groupIndex && groupIndex >= 0 ? (
    <LinkWithPulse
      href={item.url}
      key={`external-${index}-${groupIndex}`}
      className={`external-link ${cn}`}
      id="listicle:url-button"
      name="website button in listicle item"
      target="_blank"
    >
      {text}
    </LinkWithPulse>
  ) : null;
};

export default UrlWrapper;
